import React from "react";
import { Box } from "@mui/material";
import { TrackSearchResult } from "../../types/TrackSearchResult";
import { format, getLetter, trackDuration } from "../../components/text-helper/text-helper";
import { Link } from "react-router-dom";
import HighlightedText from "./HighlightedText";
import "./Search.scss";

interface TrackSearchResultProps {
    index: number;
    searchText: string;
    trackMessage: TrackSearchResult;
}

const TrackSearchComponent = (props: TrackSearchResultProps) => {    
    return (
        <Box component={Link}
            className="search-result"
            key={`$track-${props.index}`}
            to={`/letters/${getLetter(props.trackMessage.album.artistName)}/artists/${props.trackMessage.album.artistName}/albums/${props.trackMessage.album.year} - ${props.trackMessage.album.title}`}
        >
            <HighlightedText searchText={props.searchText} term={props.trackMessage.track.name} />
            #{String(props.trackMessage.track.number).padStart(2, '0')} ({trackDuration(props.trackMessage.track.duration)}) on
            <br />{props.trackMessage.album.title} ({props.trackMessage.album.year})
            <br />by {format(props.trackMessage.album.artistName)}
        </Box>
    );
}

export default TrackSearchComponent;